import { render } from "./imgMsgAdd.vue?vue&type=template&id=ff84b188"
import script from "./imgMsgAdd.vue?vue&type=script&lang=js"
export * from "./imgMsgAdd.vue?vue&type=script&lang=js"

import "./imgMsgAdd.vue?vue&type=style&index=0&id=ff84b188&lang=css"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__